import { $post } from '@js/request'

// 退出登录请求
export async function logoutRequest (): Promise<void> {
  const res = await $post('/api/common/logout')
  if (res.status !== 1) {
    throw new Error(res.message)
  }
}
